// src/components/AboutUsBanner.js
import React from 'react';
import './ServiceBanner.css'; // We’ll define styles separately

const AboutUsBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Our Services</h2>
       
      </div>
    </div>
  );
};

export default AboutUsBanner;
